import intersect from '@alpinejs/intersect';
import ajax from '@imacrayon/alpine-ajax';
// Blocks
import masonry from 'alpinejs-masonry';

import { Alpine } from '@webikon/webentor-core/_alpine';

// Components
import blogPostsFilter from './_blog-posts-filter';
import blogPostsListing from './_blog-posts-order-by';
import coursesFilter from './_courses-filter';
// Blocks Components
import { postListing } from './blocks-components/post-listing';

// Extend Alpine with more components, plugins, etc.
document.addEventListener('alpine:init', () => {
  Alpine.data('menu', function () {
    return {
      __type: 'menu',
      open: false,
      isTouch: false,
      init() {},
      openPopover(id: string) {
        this.open = id;
      },
      closePopover() {
        this.open = false;
      },
      toggle(id: string) {
        if (this.open === id) {
          this.open = false;
        } else {
          this.open = id;
        }
      },
    };
  });

  Alpine.data('postListing', postListing);
  Alpine.data('blogPostsFilter', blogPostsFilter);
  Alpine.data('blogPostsListing', blogPostsListing);
  Alpine.data('coursesFilter', coursesFilter);

  Alpine.plugin(ajax);
  Alpine.plugin(intersect);
  Alpine.plugin(masonry);
});
